import { toast } from "sonner";
import { CircleAlert } from "lucide-react";
import i18n from "@/i18n";

export const showErrorToast = (
  message: string,
  title: string = i18n.t("common.somethingWentWrong"),
) => {
  toast(title, {
    description: message,
    icon: <CircleAlert className="size-4 text-red-600" />,
    position: "bottom-center",
    duration: 5000,
  });
};
